import clsx from "clsx";
import React from "react";

interface TableWrapperProps {
	children: React.ReactNode;
	classes?: string;
	title: React.ReactNode;
	forPrint?: boolean;
}

export function TableWrapper({
	title,
	classes,
	children,
	forPrint,
}: TableWrapperProps) {
	return (
		<section
			className={clsx(classes || "results-section", {
				"results-for-print": forPrint,
			})}
		>
			<div className="table-title">{title}</div>

			{children}
		</section>
	);
}
